import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { UserAuthorization } from './user-authorization.model';
import * as UserAuthorizationActions from './user-authorization.actions';
import * as fromStore from './index';

export const userAuthorizationsFeatureKey = 'userAuthorizations';

export interface State extends EntityState<UserAuthorization> {
    // additional entities state properties

    errors: Array<string>;
    pendingCount: number;
    pendingAuthorizations: fromStore.PendingAuthorization[];
}

export const adapter: EntityAdapter<UserAuthorization> =
    createEntityAdapter<UserAuthorization>({
        selectId: (model: UserAuthorization) => model.EmpAuthID
    });

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
    errors: [],
    pendingCount: 0,
    pendingAuthorizations: []
});

export const reducer = createReducer(
    initialState,
    on(UserAuthorizationActions.addUserAuthorization, (state, action) =>
        adapter.addOne(action.userAuthorization, state)
    ),
    on(UserAuthorizationActions.upsertUserAuthorization, (state, action) =>
        adapter.upsertOne(action.userAuthorization, state)
    ),
    on(UserAuthorizationActions.addUserAuthorizations, (state, action) =>
        adapter.addMany(action.userAuthorizations, state)
    ),
    on(UserAuthorizationActions.upsertUserAuthorizations, (state, action) =>
        adapter.upsertMany(action.userAuthorizations, state)
    ),
    on(UserAuthorizationActions.updateUserAuthorization, (state, action) =>
        adapter.updateOne(action.userAuthorization, state)
    ),
    on(UserAuthorizationActions.updateUserAuthorizations, (state, action) =>
        adapter.updateMany(action.userAuthorizations, state)
    ),
    on(UserAuthorizationActions.deleteUserAuthorization, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(UserAuthorizationActions.deleteUserAuthorizations, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(UserAuthorizationActions.loadUserAuthorizations, (state, action) =>
        adapter.setAll(action.userAuthorizations, state)
    ),
    on(UserAuthorizationActions.clearUserAuthorizations, state =>
        adapter.removeAll(state)
    ),
    on(
        UserAuthorizationActions.loadPendingUserAuthorizationsCount,
        (state, action) => ({
            ...state,
            pendingCount: action.count
        })
    ),
    on(
        UserAuthorizationActions.loadPendingUserAuthorizations,
        (state, action) => ({
            ...state,
            pendingAuthorizations: action.auths
        })
    )
);
